import * as React from 'react';
import * as TFF from '@tff/types/tff';
import BookingPrices from './BookingPrices';
import AdditionalPrices from './AdditionalPrices';
import TotalAndBalance from './TotalAndBalance';

interface PricingDetailsTableProps {
  flightDetails: TFF.FlightDetails;
  midocoFlightDetails?: TFF.FlightDetails;
  serviceFeeTotalAmount?: number;
  servicePackageFee?: number;
  onDetailClick: () => void;
  retrieveDb?: TFF.BookedRetrieve;
  isNdcFlightOnlyBooking: boolean | undefined;
  isTTSBooking: boolean | undefined;
  totalBookingPrice: number;
}

const PricingDetailsTable: React.FC<PricingDetailsTableProps> = ({
  flightDetails,
  midocoFlightDetails,
  onDetailClick,
  serviceFeeTotalAmount,
  servicePackageFee,
  retrieveDb,
  isNdcFlightOnlyBooking,
  isTTSBooking,
  totalBookingPrice,
}) => {
  const orderDetails = flightDetails?.OrderDetails;
  const orderSummary = flightDetails?.OrderSummary;
  const orderDetailsMidoco = midocoFlightDetails?.OrderDetails;

  return (
    <>
      <div className="tff-pricing-details-container">
        <BookingPrices orderDetails={orderDetails} orderSummary={orderSummary} onDetailClick={onDetailClick} />
        <AdditionalPrices
          retrieveDb={retrieveDb}
          servicePackageFee={servicePackageFee}
          serviceFeeTotalAmount={serviceFeeTotalAmount}
          isNdcFlightOnlyBooking={isNdcFlightOnlyBooking}
          orderDetailsMidoco={orderDetailsMidoco}
          isTTSBooking={isTTSBooking}
        />
      </div>
      <div>
        <TotalAndBalance
          midocoFlightDetails={midocoFlightDetails}
          totalBookingPrice={totalBookingPrice}
          retrieveDb={retrieveDb}
        />
      </div>
    </>
  );
};

export default PricingDetailsTable;
